const overloading = {
  breakpointNames: ['sm', 'md', 'lg', 'xl', 'xxl'],
  breakpoints: [576, 768, 992, 1200, 1600]
}

const variables = {
  familyBase: '"proxima-nova",sans-serif',
  familyHeader: '"proxima-nova",serif',

  primaryColor: '#1f4f9c',
  fontColor: '#231f20',
  bgColor: '#ebebeb',
  lightBlue : '#00aeef',
  
  ...overloading
}

export default variables;